/**
 * @name BadgeStatus
 * @description Componente para mostrar el estatus de una actividad
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled, { css } from 'styled-components';

import { Typography } from '@tycommon/styles';

/* 
  ---------------------------
  ESTATUS DE LAS ACTIVIDADES
  ---------------------------
  1 - Pendiente | POR ACEPTAR
  2 - Rechazada | POR REASIGNAR
  3 - Aceptada | EN PROGRESO
  4 - Concluida
*/

const BadgeStatus = (props) => {
  const { statusId, showBadge } = props;

  return (
    <Styled.Badge status={statusId} showBadge={showBadge}>
      <Styled.StatusDot status={statusId} />
      <Styled.StatusText status={statusId}>
        {statusId === 1 && i18n.t('BackupSettings.confirmed')}
        {statusId === 2 && i18n.t('BackupSettings.rejected')}
        {statusId === 3 && i18n.t('BackupSettings.cancelled')}
        {statusId === 4 && i18n.t('BackupSettings.finalized')}
      </Styled.StatusText>
    </Styled.Badge>
  );
};

BadgeStatus.propTypes = {
  // Id que indica el tipo de estatus del componente.
  statusId: PropTypes.number.isRequired,
  // Boolean que indica si se muestra el badge.
  showBadge: PropTypes.bool
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.Badge = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  ${(props) => props.showBadge && css`
    padding: 4px 12px;
    border-radius: 12px;
    ${(props) => props.status === 4 && css`background-color: ${(props) => props.theme.colors.greyHover};`};
    ${(props) => props.status === 3 && css`background-color: ${(props) => props.theme.colors.orangeAlpha};`};
    ${(props) => props.status === 2 && css`background-color: ${(props) => props.theme.colors.orangeAlpha};`};
    ${(props) => props.status === 1 && css`background-color: ${(props) => props.theme.colors.greenAlpha};`};
  `};
`;

Styled.StatusDot = styled.div`
  width: 8px;
  height: 8px; 
  min-width: 8px;
  min-height: 8px;
  border-radius: 50%; 
  margin-right: 8px;
  ${(props) => props.status === 4 && css`background-color: ${(props) => props.theme.colors.greyDarkAlpha};`};
  ${(props) => props.status === 3 && css`background-color: ${(props) => props.theme.colors.orange};`};
  ${(props) => props.status === 2 && css`background-color: ${(props) => props.theme.colors.orange};`};
  ${(props) => props.status === 1 && css`background-color: ${(props) => props.theme.colors.green};`};
`;

Styled.StatusText = styled(Typography.Text)`
  ${(props) => props.status === 4 && css`color: ${(props) => props.theme.colors.greyDarkAlpha};`};
  ${(props) => props.status === 3 && css`color: ${(props) => props.theme.colors.orange};`};
  ${(props) => props.status === 2 && css`color: ${(props) => props.theme.colors.orange};`};
  ${(props) => props.status === 1 && css`color: ${(props) => props.theme.colors.green};`};
`;

export default BadgeStatus;